/*
 *  * Copyright (©)  2018 by INFODATA-GROUP. All rights reserved.
 *  * No part of this publication may be reproduced, distributed,
 *  * or transmitted in any form or by any means, including photocopying, recording,
 *  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  * except in the case of brief quotations embodied in critical
 *  * reviews and certain other noncommercial uses permitted by copyright law.
 *  * author : bs
 *  * date : 23/08/2019 11:43
 */

import { StandardEntity } from '@infodata-group/inf-commons';
import { Address } from '../engine/address';

export class Company extends StandardEntity {
  public address: Address;
  public colors: string[] = [];

  constructor(id: string, label: string) {
    super(id, label, 'label');
  }
}
